import Vue from "vue";
import Vuex from "vuex";

import home from './modules/home'
import memorialhall from './modules/memorialhall'
import account from './modules/account'
import obit from './modules/obit'
import memorialArticle from './modules/memorialArticle'
import music from './modules/music.js'
import user from './modules/user.js'
import commandComment from './modules/commandComment'
import mailBox from './modules/mailBox'
import search from './modules/search'
import genericArticle from './modules/genericArticle'
import today from './modules/today'
import imageManage from './modules/imageManage'
import image from './modules/Image'
import video from './modules/video'
import musicInfo from './modules/musicInfo'
import distributionLevel from './modules/distributionLevel'
import memberRelation from './modules/memberRelation'
import receipts from './modules/receipts'
import distributionProduct from './modules/distributionProduct'
import shared from './modules/shared'
import template from './modules/template'
import memorialManage from './modules/memorialManage'
import product from './modules/product'
import cemetery from './modules/cemetery'
import mourningHall from './modules/mourningHall'
import sacrificeLog from './modules/sacrificeLog'
import sacrifice from './modules/sacrifice'
import transactionOrder from './modules/transactionOrder'
import transactionDetail from './modules/transactionDetail'
import member from './modules/member'
import visitCaller from './modules/visitCaller'
import musicInfoManage from './modules/musicInfoManage'
import transaction from './modules/transaction'
import htmlInfo from './modules/htmlInfo'
import memberPhoneAuth from './modules/memberPhoneAuth'
import addressManage from './modules/addressManage'
import accountManage from './modules/accountManage'
import transactionDetailApply from './modules/transactionDetailApply'
import memberIntegral from './modules/memberIntegral'
import transactionDetailTurnCash from './modules/transactionDetailTurnCash'
import transactionDetailTurnCoin from './modules/transactionDetailTurnCoin'
import activity from './modules/activity'
import signIn from './modules/signIn'
import memberAgentCommission from './modules/memberAgentCommission'
import webHome from './modules/appHome'
import commandAd from './modules/commandAd'
import memorialHallApply from './modules/memorialHallApply'
import dataDictionaryItem from './modules/dataDictionaryItem.js'
import frienMemberTeam from './modules/frienMemberTeam.js'
import createPersistedState from "vuex-persistedstate" // state持久化存储
import memberQrcode from './modules/memberQrcode.js'
import customRemark from './modules/customRemark.js'

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState({
    paths:['mid','muid','productApiModel','placeType','sacrificemodel','playControl','addressManage']
  })],
  state: {
    mid : null,
    muid : null,
    productApiModel: null,
    placeType : 0,
    sacrificemodel : null,
    sacrificemodelList:null,
    playControl : {},
  },
  mutations: {
    setmid(state, payload){
      state.mid = payload;
    },
    setmuid(state, payload){
      state.muid = payload;
    },
    setProductApiModel(state, payload){
      state.productApiModel = payload;
    },
    setPlaceType(state, payload){
      state.placeType = payload;
    },
    setSacrifice(state, payload){
      state.sacrificemodel = payload;
    },
    setSacrificeList(state, payload)
    {
      state.sacrificemodelList=payload;
    },
    delSacrifice(state, payload){
      state.sacrificemodel = null;
    },
    delSacrificeList(state, payload){
      state.sacrificemodelList = null;
    },
    setPlayControl(state, payload){
      if(state.playControl[payload.id] == undefined){
        state.playControl[payload.id] = {play : payload.play}
      }else{
        state.playControl[payload.id].play = payload.play;
      }
    },
    setPlayControlurl(state, payload){
      state.playControl[payload.id].url = payload.url;
      state.playControl[payload.id].time = payload.time;
    }
    

  },
  actions: {},
  modules: {
    memorialhall,
    account,
    obit,
    memorialArticle,
    music,
    user,
    home,
    commandComment,
    mailBox,
    search,
    genericArticle,
    today,
    imageManage,
    image,
    video,
    musicInfo,
    distributionLevel,
    memberRelation,
    receipts,
    distributionProduct,
    shared,
    template,
    memorialManage,
    product,
    cemetery,
    mourningHall,
    sacrificeLog,
    sacrifice,
    transactionOrder,
    transactionDetail,
    member,
    visitCaller,
    musicInfoManage,
    transaction,
    htmlInfo,
    memberPhoneAuth,
    addressManage,
    accountManage,
    transactionDetailApply,
    memberIntegral,
    transactionDetailTurnCash,
    transactionDetailTurnCoin,
    activity,
    signIn,
    memberAgentCommission,
    webHome,
    commandAd,
    memorialHallApply,
    dataDictionaryItem,
    frienMemberTeam,
    memberQrcode,
    customRemark
  }
});
